export default class EventBus {
    constructor() {
        this._listeners = {};
    }

    subscribe(event, callback) {
        if (typeof event === 'function') {
            callback = event;
            event = '*';
        } else if (typeof callback !== 'function') {
            throw new TypeError('The "callback" argument must be of type function');
        }
        if (!this._listeners[event]) {
            this._listeners[event] = [];
        }
        this._listeners[event].push(callback);
        return () => this.unsubscribe(event, callback);
    }

    unsubscribe(event, callback) {
        if (typeof event === 'function') {
            callback = event;
            event = '*';
        }
        if (!this._listeners[event]) {
            return;
        }
        this._listeners[event] = this._listeners[event].filter((fn) => fn !== callback);
    }

    emit(event, data, meta = {}) {
        if (event !== '*' && this._listeners[event]) {
            this._listeners[event].forEach((callback) => callback(data, meta));
        }
        if (this._listeners['*']) {
            this._listeners['*'].forEach((callback) => callback(event, data, meta));
        }
    }
}
